// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  backendApiAdminLevelsFindAll,
  backendApiAdminLevelsFindOne,
  backendApiAuthenticationGetUser,
  backendApiAuthenticationGetWfsAuthorization,
  backendApiAuthenticationLogin,
  backendApiAuthenticationLogout,
  backendApiAuthenticationSamlAssertionConsumer,
  backendApiAuthenticationSamlLogout,
  backendApiAuthenticationSamlMetadata,
  backendApiAuthenticationSamlSingleLogout,
  backendApiBemasImportImportOrganizations,
  backendApiBemasImportImportPolice,
  backendApiCaslGetRules,
  backendApiExternalSignsImport,
  backendApiExternalSignsUpload,
  backendApiGeocoderGeocode,
  backendApiGeocoderReverse,
  backendApiHealthCheck,
  backendApiOpenLrImport,
  backendApiOrganizationsCreate,
  backendApiOrganizationsCreateOrganizationAdminLevel,
  backendApiOrganizationsCreateOrganizationStakeholder,
  backendApiOrganizationsCreateOrganizationUser,
  backendApiOrganizationsFindAll,
  backendApiOrganizationsFindOne,
  backendApiOrganizationsFindOneOrganizationAdminLevel,
  backendApiOrganizationsFindOneOrganizationUser,
  backendApiOrganizationsFindOrganizationStakeholder,
  backendApiOrganizationsRemoveOrganizationAdminLevel,
  backendApiOrganizationsRemoveOrganizationStakeholder,
  backendApiOrganizationsRemoveOrganizationUser,
  backendApiOrganizationsUpdate,
  backendApiOrganizationsUpdateOrganizationAdminLevel,
  backendApiOrganizationsUpdateOrganizationUser,
  backendApiProcessesAddSign,
  backendApiProcessesCancelProcess,
  backendApiProcessesCreate,
  backendApiProcessesCreateExamination,
  backendApiProcessesFinalizeProcess,
  backendApiProcessesFindAll,
  backendApiProcessesFindAllFiles,
  backendApiProcessesFindAllNotifications,
  backendApiProcessesFindOne,
  backendApiProcessesFindOneExaminationPublic,
  backendApiProcessesFindOneExecutionPublic,
  backendApiProcessesFindOneFile,
  backendApiProcessesGeneratePdf,
  backendApiProcessesRemove,
  backendApiProcessesRemoveExamination,
  backendApiProcessesRemoveFile,
  backendApiProcessesRemoveSign,
  backendApiProcessesUpdate,
  backendApiProcessesUpdateExamination,
  backendApiProcessesUpdateExaminationPublic,
  backendApiProcessesUpdateExecutionPublic,
  backendApiProcessesUpdateExternal,
  backendApiProcessesUpdateStepDecision,
  backendApiProcessesUpdateStepDraft,
  backendApiProcessesUpdateStepExamination,
  backendApiProcessesUpdateStepExecution,
  backendApiProcessesUploadFile,
  backendApiSignCodesFindAll,
  backendApiSignCodesFindOne,
  backendApiSignGroupsCreate,
  backendApiSignGroupsFindOne,
  backendApiSignGroupsRemove,
  backendApiSignGroupsUpdate,
  backendApiSignGroupsUpdateOpenLr,
  backendApiSignImagesFindAll,
  backendApiSignImagesFindOne,
  backendApiSignImagesRemove,
  backendApiSignImagesUpload,
  backendApiSignsCreate,
  backendApiSignsCreateStatus,
  backendApiSignsFindAll,
  backendApiSignsFindAllProcessSuggestion,
  backendApiSignsFindOne,
  backendApiSignsRemove,
  backendApiSignsUpdate,
  backendApiSignSupportsCreate,
  backendApiSignSupportsFindOne,
  backendApiSignSupportsRemove,
  backendApiSignSupportsUpdate,
  backendApiUsersCreate,
  backendApiUsersFindAll,
  backendApiUsersFindOne,
  backendApiUsersRemove,
  backendApiUsersUpdate,
  type Options,
} from '../sdk.gen';
import type {
  AdminLevelsFindAllData,
  AdminLevelsFindAllResponse,
  AdminLevelsFindOneData,
  AdminLevelsFindOneResponse,
  AuthenticationGetUserData,
  AuthenticationGetUserResponse,
  AuthenticationGetWfsAuthorizationData,
  AuthenticationGetWfsAuthorizationResponse,
  AuthenticationLoginData,
  AuthenticationLogoutData,
  AuthenticationSamlAssertionConsumerData,
  AuthenticationSamlLogoutData,
  AuthenticationSamlMetadataData,
  AuthenticationSamlMetadataResponse,
  AuthenticationSamlSingleLogoutData,
  BemasImportImportOrganizationsData,
  BemasImportImportOrganizationsResponse,
  BemasImportImportPoliceData,
  BemasImportImportPoliceResponse,
  CaslGetRulesData,
  CaslGetRulesResponse,
  ExternalSignsImportData,
  ExternalSignsImportResponse,
  ExternalSignsUploadData,
  GeocoderGeocodeData,
  GeocoderGeocodeResponse,
  GeocoderReverseData,
  GeocoderReverseResponse,
  HealthCheckData,
  HealthCheckError,
  HealthCheckResponse,
  OpenLrImportData,
  OpenLrImportResponse,
  OrganizationsCreateData,
  OrganizationsCreateOrganizationAdminLevelData,
  OrganizationsCreateOrganizationAdminLevelResponse,
  OrganizationsCreateOrganizationStakeholderData,
  OrganizationsCreateOrganizationStakeholderResponse,
  OrganizationsCreateOrganizationUserData,
  OrganizationsCreateOrganizationUserResponse,
  OrganizationsCreateResponse,
  OrganizationsFindAllData,
  OrganizationsFindAllResponse,
  OrganizationsFindOneData,
  OrganizationsFindOneOrganizationAdminLevelData,
  OrganizationsFindOneOrganizationAdminLevelResponse,
  OrganizationsFindOneOrganizationUserData,
  OrganizationsFindOneOrganizationUserResponse,
  OrganizationsFindOneResponse,
  OrganizationsFindOrganizationStakeholderData,
  OrganizationsFindOrganizationStakeholderResponse,
  OrganizationsRemoveOrganizationAdminLevelData,
  OrganizationsRemoveOrganizationAdminLevelResponse,
  OrganizationsRemoveOrganizationStakeholderData,
  OrganizationsRemoveOrganizationStakeholderResponse,
  OrganizationsRemoveOrganizationUserData,
  OrganizationsRemoveOrganizationUserResponse,
  OrganizationsUpdateData,
  OrganizationsUpdateOrganizationAdminLevelData,
  OrganizationsUpdateOrganizationAdminLevelResponse,
  OrganizationsUpdateOrganizationUserData,
  OrganizationsUpdateOrganizationUserResponse,
  OrganizationsUpdateResponse,
  ProcessesAddSignData,
  ProcessesAddSignResponse,
  ProcessesCancelProcessData,
  ProcessesCancelProcessResponse,
  ProcessesCreateData,
  ProcessesCreateExaminationData,
  ProcessesCreateExaminationResponse,
  ProcessesCreateResponse,
  ProcessesFinalizeProcessData,
  ProcessesFinalizeProcessResponse,
  ProcessesFindAllData,
  ProcessesFindAllFilesData,
  ProcessesFindAllFilesResponse,
  ProcessesFindAllNotificationsData,
  ProcessesFindAllNotificationsResponse,
  ProcessesFindAllResponse,
  ProcessesFindOneData,
  ProcessesFindOneExaminationPublicData,
  ProcessesFindOneExaminationPublicResponse,
  ProcessesFindOneExecutionPublicData,
  ProcessesFindOneExecutionPublicResponse,
  ProcessesFindOneFileData,
  ProcessesFindOneFileResponse,
  ProcessesFindOneResponse,
  ProcessesGeneratePdfData,
  ProcessesGeneratePdfResponse,
  ProcessesRemoveData,
  ProcessesRemoveExaminationData,
  ProcessesRemoveExaminationResponse,
  ProcessesRemoveFileData,
  ProcessesRemoveFileResponse,
  ProcessesRemoveResponse,
  ProcessesRemoveSignData,
  ProcessesRemoveSignResponse,
  ProcessesUpdateData,
  ProcessesUpdateExaminationData,
  ProcessesUpdateExaminationPublicData,
  ProcessesUpdateExaminationPublicResponse,
  ProcessesUpdateExaminationResponse,
  ProcessesUpdateExecutionPublicData,
  ProcessesUpdateExecutionPublicResponse,
  ProcessesUpdateExternalData,
  ProcessesUpdateExternalResponse,
  ProcessesUpdateResponse,
  ProcessesUpdateStepDecisionData,
  ProcessesUpdateStepDecisionResponse,
  ProcessesUpdateStepDraftData,
  ProcessesUpdateStepDraftResponse,
  ProcessesUpdateStepExaminationData,
  ProcessesUpdateStepExaminationResponse,
  ProcessesUpdateStepExecutionData,
  ProcessesUpdateStepExecutionResponse,
  ProcessesUploadFileData,
  ProcessesUploadFileResponse,
  SignCodesFindAllData,
  SignCodesFindAllResponse,
  SignCodesFindOneData,
  SignCodesFindOneResponse,
  SignGroupsCreateData,
  SignGroupsCreateResponse,
  SignGroupsFindOneData,
  SignGroupsFindOneResponse,
  SignGroupsRemoveData,
  SignGroupsRemoveResponse,
  SignGroupsUpdateData,
  SignGroupsUpdateOpenLrData,
  SignGroupsUpdateResponse,
  SignImagesFindAllData,
  SignImagesFindAllResponse,
  SignImagesFindOneData,
  SignImagesFindOneResponse,
  SignImagesRemoveData,
  SignImagesRemoveResponse,
  SignImagesUploadData,
  SignImagesUploadResponse,
  SignsCreateData,
  SignsCreateResponse,
  SignsCreateStatusData,
  SignsCreateStatusResponse,
  SignsFindAllData,
  SignsFindAllProcessSuggestionData,
  SignsFindAllProcessSuggestionResponse,
  SignsFindAllResponse,
  SignsFindOneData,
  SignsFindOneResponse,
  SignsRemoveData,
  SignsRemoveResponse,
  SignsUpdateData,
  SignsUpdateResponse,
  SignSupportsCreateData,
  SignSupportsCreateResponse,
  SignSupportsFindOneData,
  SignSupportsFindOneResponse,
  SignSupportsRemoveData,
  SignSupportsRemoveResponse,
  SignSupportsUpdateData,
  SignSupportsUpdateResponse,
  UsersCreateData,
  UsersCreateResponse,
  UsersFindAllData,
  UsersFindAllResponse,
  UsersFindOneData,
  UsersFindOneResponse,
  UsersRemoveData,
  UsersRemoveResponse,
  UsersUpdateData,
  UsersUpdateResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const backendApiHealthCheckQueryKey = (options?: Options<HealthCheckData>) =>
  createQueryKey('healthCheck', options);

export const backendApiHealthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<
    HealthCheckResponse,
    HealthCheckError,
    HealthCheckResponse,
    ReturnType<typeof backendApiHealthCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiHealthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiHealthCheckQueryKey(options),
  });

export const backendApiAuthenticationLoginQueryKey = (options?: Options<AuthenticationLoginData>) =>
  createQueryKey('authenticationLogin', options);

export const backendApiAuthenticationLoginOptions = (options?: Options<AuthenticationLoginData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationLoginQueryKey(options),
  });

export const backendApiAuthenticationSamlAssertionConsumerMutation = (
  options?: Partial<Options<AuthenticationSamlAssertionConsumerData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlAssertionConsumerData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlAssertionConsumerData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationSamlAssertionConsumer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationLogoutMutation = (
  options?: Partial<Options<AuthenticationLogoutData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationSamlLogoutMutation = (
  options?: Partial<Options<AuthenticationSamlLogoutData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationSamlLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationSamlLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationSamlSingleLogoutQueryKey = (
  options?: Options<AuthenticationSamlSingleLogoutData>,
) => createQueryKey('authenticationSamlSingleLogout', options);

export const backendApiAuthenticationSamlSingleLogoutOptions = (
  options?: Options<AuthenticationSamlSingleLogoutData>,
) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationSamlSingleLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlSingleLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlSingleLogoutQueryKey(options),
  });

export const backendApiAuthenticationSamlMetadataQueryKey = (options?: Options<AuthenticationSamlMetadataData>) =>
  createQueryKey('authenticationSamlMetadata', options);

export const backendApiAuthenticationSamlMetadataOptions = (options?: Options<AuthenticationSamlMetadataData>) =>
  queryOptions<
    AuthenticationSamlMetadataResponse,
    DefaultError,
    AuthenticationSamlMetadataResponse,
    ReturnType<typeof backendApiAuthenticationSamlMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationSamlMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationSamlMetadataQueryKey(options),
  });

export const backendApiAuthenticationGetUserQueryKey = (options?: Options<AuthenticationGetUserData>) =>
  createQueryKey('authenticationGetUser', options);

export const backendApiAuthenticationGetUserOptions = (options?: Options<AuthenticationGetUserData>) =>
  queryOptions<
    AuthenticationGetUserResponse,
    DefaultError,
    AuthenticationGetUserResponse,
    ReturnType<typeof backendApiAuthenticationGetUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationGetUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationGetUserQueryKey(options),
  });

export const backendApiAuthenticationGetWfsAuthorizationQueryKey = (
  options?: Options<AuthenticationGetWfsAuthorizationData>,
) => createQueryKey('authenticationGetWfsAuthorization', options);

export const backendApiAuthenticationGetWfsAuthorizationOptions = (
  options?: Options<AuthenticationGetWfsAuthorizationData>,
) =>
  queryOptions<
    AuthenticationGetWfsAuthorizationResponse,
    DefaultError,
    AuthenticationGetWfsAuthorizationResponse,
    ReturnType<typeof backendApiAuthenticationGetWfsAuthorizationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationGetWfsAuthorization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationGetWfsAuthorizationQueryKey(options),
  });

export const backendApiCaslGetRulesQueryKey = (options?: Options<CaslGetRulesData>) =>
  createQueryKey('caslGetRules', options);

export const backendApiCaslGetRulesOptions = (options?: Options<CaslGetRulesData>) =>
  queryOptions<
    CaslGetRulesResponse,
    DefaultError,
    CaslGetRulesResponse,
    ReturnType<typeof backendApiCaslGetRulesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiCaslGetRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiCaslGetRulesQueryKey(options),
  });

export const backendApiUsersFindAllQueryKey = (options?: Options<UsersFindAllData>) =>
  createQueryKey('usersFindAll', options);

export const backendApiUsersFindAllOptions = (options?: Options<UsersFindAllData>) =>
  queryOptions<
    UsersFindAllResponse,
    DefaultError,
    UsersFindAllResponse,
    ReturnType<typeof backendApiUsersFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindAllQueryKey(options),
  });

export const backendApiUsersCreateMutation = (
  options?: Partial<Options<UsersCreateData>>,
): UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> => {
  const mutationOptions: UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersRemoveMutation = (
  options?: Partial<Options<UsersRemoveData>>,
): UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> => {
  const mutationOptions: UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersFindOneQueryKey = (options: Options<UsersFindOneData>) =>
  createQueryKey('usersFindOne', options);

export const backendApiUsersFindOneOptions = (options: Options<UsersFindOneData>) =>
  queryOptions<
    UsersFindOneResponse,
    DefaultError,
    UsersFindOneResponse,
    ReturnType<typeof backendApiUsersFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindOneQueryKey(options),
  });

export const backendApiUsersUpdateMutation = (
  options?: Partial<Options<UsersUpdateData>>,
): UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> => {
  const mutationOptions: UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAdminLevelsFindAllQueryKey = (options?: Options<AdminLevelsFindAllData>) =>
  createQueryKey('adminLevelsFindAll', options);

export const backendApiAdminLevelsFindAllOptions = (options?: Options<AdminLevelsFindAllData>) =>
  queryOptions<
    AdminLevelsFindAllResponse,
    DefaultError,
    AdminLevelsFindAllResponse,
    ReturnType<typeof backendApiAdminLevelsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsFindAllQueryKey(options),
  });

export const backendApiAdminLevelsFindOneQueryKey = (options: Options<AdminLevelsFindOneData>) =>
  createQueryKey('adminLevelsFindOne', options);

export const backendApiAdminLevelsFindOneOptions = (options: Options<AdminLevelsFindOneData>) =>
  queryOptions<
    AdminLevelsFindOneResponse,
    DefaultError,
    AdminLevelsFindOneResponse,
    ReturnType<typeof backendApiAdminLevelsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAdminLevelsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAdminLevelsFindOneQueryKey(options),
  });

export const backendApiGeocoderGeocodeQueryKey = (options: Options<GeocoderGeocodeData>) =>
  createQueryKey('geocoderGeocode', options);

export const backendApiGeocoderGeocodeOptions = (options: Options<GeocoderGeocodeData>) =>
  queryOptions<
    GeocoderGeocodeResponse,
    DefaultError,
    GeocoderGeocodeResponse,
    ReturnType<typeof backendApiGeocoderGeocodeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiGeocoderGeocode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiGeocoderGeocodeQueryKey(options),
  });

export const backendApiGeocoderReverseQueryKey = (options: Options<GeocoderReverseData>) =>
  createQueryKey('geocoderReverse', options);

export const backendApiGeocoderReverseOptions = (options: Options<GeocoderReverseData>) =>
  queryOptions<
    GeocoderReverseResponse,
    DefaultError,
    GeocoderReverseResponse,
    ReturnType<typeof backendApiGeocoderReverseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiGeocoderReverse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiGeocoderReverseQueryKey(options),
  });

export const backendApiOrganizationsFindAllQueryKey = (options?: Options<OrganizationsFindAllData>) =>
  createQueryKey('organizationsFindAll', options);

export const backendApiOrganizationsFindAllOptions = (options?: Options<OrganizationsFindAllData>) =>
  queryOptions<
    OrganizationsFindAllResponse,
    DefaultError,
    OrganizationsFindAllResponse,
    ReturnType<typeof backendApiOrganizationsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindAllQueryKey(options),
  });

export const backendApiOrganizationsCreateMutation = (
  options?: Partial<Options<OrganizationsCreateData>>,
): UseMutationOptions<OrganizationsCreateResponse, DefaultError, Options<OrganizationsCreateData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateResponse,
    DefaultError,
    Options<OrganizationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOneQueryKey = (options: Options<OrganizationsFindOneData>) =>
  createQueryKey('organizationsFindOne', options);

export const backendApiOrganizationsFindOneOptions = (options: Options<OrganizationsFindOneData>) =>
  queryOptions<
    OrganizationsFindOneResponse,
    DefaultError,
    OrganizationsFindOneResponse,
    ReturnType<typeof backendApiOrganizationsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOneQueryKey(options),
  });

export const backendApiOrganizationsUpdateMutation = (
  options?: Partial<Options<OrganizationsUpdateData>>,
): UseMutationOptions<OrganizationsUpdateResponse, DefaultError, Options<OrganizationsUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUpdateResponse,
    DefaultError,
    Options<OrganizationsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsRemoveOrganizationAdminLevelMutation = (
  options?: Partial<Options<OrganizationsRemoveOrganizationAdminLevelData>>,
): UseMutationOptions<
  OrganizationsRemoveOrganizationAdminLevelResponse,
  DefaultError,
  Options<OrganizationsRemoveOrganizationAdminLevelData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRemoveOrganizationAdminLevelResponse,
    DefaultError,
    Options<OrganizationsRemoveOrganizationAdminLevelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsRemoveOrganizationAdminLevel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOneOrganizationAdminLevelQueryKey = (
  options: Options<OrganizationsFindOneOrganizationAdminLevelData>,
) => createQueryKey('organizationsFindOneOrganizationAdminLevel', options);

export const backendApiOrganizationsFindOneOrganizationAdminLevelOptions = (
  options: Options<OrganizationsFindOneOrganizationAdminLevelData>,
) =>
  queryOptions<
    OrganizationsFindOneOrganizationAdminLevelResponse,
    DefaultError,
    OrganizationsFindOneOrganizationAdminLevelResponse,
    ReturnType<typeof backendApiOrganizationsFindOneOrganizationAdminLevelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOneOrganizationAdminLevel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOneOrganizationAdminLevelQueryKey(options),
  });

export const backendApiOrganizationsUpdateOrganizationAdminLevelMutation = (
  options?: Partial<Options<OrganizationsUpdateOrganizationAdminLevelData>>,
): UseMutationOptions<
  OrganizationsUpdateOrganizationAdminLevelResponse,
  DefaultError,
  Options<OrganizationsUpdateOrganizationAdminLevelData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUpdateOrganizationAdminLevelResponse,
    DefaultError,
    Options<OrganizationsUpdateOrganizationAdminLevelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsUpdateOrganizationAdminLevel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsCreateOrganizationAdminLevelMutation = (
  options?: Partial<Options<OrganizationsCreateOrganizationAdminLevelData>>,
): UseMutationOptions<
  OrganizationsCreateOrganizationAdminLevelResponse,
  DefaultError,
  Options<OrganizationsCreateOrganizationAdminLevelData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateOrganizationAdminLevelResponse,
    DefaultError,
    Options<OrganizationsCreateOrganizationAdminLevelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreateOrganizationAdminLevel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsRemoveOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsRemoveOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsRemoveOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsRemoveOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRemoveOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsRemoveOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsRemoveOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOneOrganizationUserQueryKey = (
  options: Options<OrganizationsFindOneOrganizationUserData>,
) => createQueryKey('organizationsFindOneOrganizationUser', options);

export const backendApiOrganizationsFindOneOrganizationUserOptions = (
  options: Options<OrganizationsFindOneOrganizationUserData>,
) =>
  queryOptions<
    OrganizationsFindOneOrganizationUserResponse,
    DefaultError,
    OrganizationsFindOneOrganizationUserResponse,
    ReturnType<typeof backendApiOrganizationsFindOneOrganizationUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOneOrganizationUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOneOrganizationUserQueryKey(options),
  });

export const backendApiOrganizationsUpdateOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsUpdateOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsUpdateOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsUpdateOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUpdateOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsUpdateOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsUpdateOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsCreateOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsCreateOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsCreateOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsCreateOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsCreateOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreateOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOrganizationStakeholderQueryKey = (
  options: Options<OrganizationsFindOrganizationStakeholderData>,
) => createQueryKey('organizationsFindOrganizationStakeholder', options);

export const backendApiOrganizationsFindOrganizationStakeholderOptions = (
  options: Options<OrganizationsFindOrganizationStakeholderData>,
) =>
  queryOptions<
    OrganizationsFindOrganizationStakeholderResponse,
    DefaultError,
    OrganizationsFindOrganizationStakeholderResponse,
    ReturnType<typeof backendApiOrganizationsFindOrganizationStakeholderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOrganizationStakeholder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOrganizationStakeholderQueryKey(options),
  });

export const backendApiOrganizationsCreateOrganizationStakeholderMutation = (
  options?: Partial<Options<OrganizationsCreateOrganizationStakeholderData>>,
): UseMutationOptions<
  OrganizationsCreateOrganizationStakeholderResponse,
  DefaultError,
  Options<OrganizationsCreateOrganizationStakeholderData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateOrganizationStakeholderResponse,
    DefaultError,
    Options<OrganizationsCreateOrganizationStakeholderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreateOrganizationStakeholder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsRemoveOrganizationStakeholderMutation = (
  options?: Partial<Options<OrganizationsRemoveOrganizationStakeholderData>>,
): UseMutationOptions<
  OrganizationsRemoveOrganizationStakeholderResponse,
  DefaultError,
  Options<OrganizationsRemoveOrganizationStakeholderData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRemoveOrganizationStakeholderResponse,
    DefaultError,
    Options<OrganizationsRemoveOrganizationStakeholderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsRemoveOrganizationStakeholder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignSupportsCreateMutation = (
  options?: Partial<Options<SignSupportsCreateData>>,
): UseMutationOptions<SignSupportsCreateResponse, DefaultError, Options<SignSupportsCreateData>> => {
  const mutationOptions: UseMutationOptions<
    SignSupportsCreateResponse,
    DefaultError,
    Options<SignSupportsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignSupportsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignSupportsRemoveMutation = (
  options?: Partial<Options<SignSupportsRemoveData>>,
): UseMutationOptions<SignSupportsRemoveResponse, DefaultError, Options<SignSupportsRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    SignSupportsRemoveResponse,
    DefaultError,
    Options<SignSupportsRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignSupportsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignSupportsFindOneQueryKey = (options: Options<SignSupportsFindOneData>) =>
  createQueryKey('signSupportsFindOne', options);

export const backendApiSignSupportsFindOneOptions = (options: Options<SignSupportsFindOneData>) =>
  queryOptions<
    SignSupportsFindOneResponse,
    DefaultError,
    SignSupportsFindOneResponse,
    ReturnType<typeof backendApiSignSupportsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignSupportsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignSupportsFindOneQueryKey(options),
  });

export const backendApiSignSupportsUpdateMutation = (
  options?: Partial<Options<SignSupportsUpdateData>>,
): UseMutationOptions<SignSupportsUpdateResponse, DefaultError, Options<SignSupportsUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    SignSupportsUpdateResponse,
    DefaultError,
    Options<SignSupportsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignSupportsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignGroupsCreateMutation = (
  options?: Partial<Options<SignGroupsCreateData>>,
): UseMutationOptions<SignGroupsCreateResponse, DefaultError, Options<SignGroupsCreateData>> => {
  const mutationOptions: UseMutationOptions<SignGroupsCreateResponse, DefaultError, Options<SignGroupsCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignGroupsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignGroupsRemoveMutation = (
  options?: Partial<Options<SignGroupsRemoveData>>,
): UseMutationOptions<SignGroupsRemoveResponse, DefaultError, Options<SignGroupsRemoveData>> => {
  const mutationOptions: UseMutationOptions<SignGroupsRemoveResponse, DefaultError, Options<SignGroupsRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignGroupsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignGroupsFindOneQueryKey = (options: Options<SignGroupsFindOneData>) =>
  createQueryKey('signGroupsFindOne', options);

export const backendApiSignGroupsFindOneOptions = (options: Options<SignGroupsFindOneData>) =>
  queryOptions<
    SignGroupsFindOneResponse,
    DefaultError,
    SignGroupsFindOneResponse,
    ReturnType<typeof backendApiSignGroupsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignGroupsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignGroupsFindOneQueryKey(options),
  });

export const backendApiSignGroupsUpdateMutation = (
  options?: Partial<Options<SignGroupsUpdateData>>,
): UseMutationOptions<SignGroupsUpdateResponse, DefaultError, Options<SignGroupsUpdateData>> => {
  const mutationOptions: UseMutationOptions<SignGroupsUpdateResponse, DefaultError, Options<SignGroupsUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignGroupsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignGroupsUpdateOpenLrMutation = (
  options?: Partial<Options<SignGroupsUpdateOpenLrData>>,
): UseMutationOptions<unknown, DefaultError, Options<SignGroupsUpdateOpenLrData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SignGroupsUpdateOpenLrData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignGroupsUpdateOpenLr({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignsFindAllQueryKey = (options: Options<SignsFindAllData>) =>
  createQueryKey('signsFindAll', options);

export const backendApiSignsFindAllOptions = (options: Options<SignsFindAllData>) =>
  queryOptions<
    SignsFindAllResponse,
    DefaultError,
    SignsFindAllResponse,
    ReturnType<typeof backendApiSignsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignsFindAllQueryKey(options),
  });

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const signsFindAllInfiniteQueryKey = (options: Options<SignsFindAllData>): QueryKey<Options<SignsFindAllData>> =>
  createQueryKey('signsFindAll', options, true);

export const signsFindAllInfiniteOptions = (options: Options<SignsFindAllData>) =>
  infiniteQueryOptions<
    SignsFindAllResponse,
    DefaultError,
    InfiniteData<SignsFindAllResponse>,
    QueryKey<Options<SignsFindAllData>>,
    number | Pick<QueryKey<Options<SignsFindAllData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SignsFindAllData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await backendApiSignsFindAll({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: signsFindAllInfiniteQueryKey(options),
    },
  );

export const backendApiSignsCreateMutation = (
  options?: Partial<Options<SignsCreateData>>,
): UseMutationOptions<SignsCreateResponse, DefaultError, Options<SignsCreateData>> => {
  const mutationOptions: UseMutationOptions<SignsCreateResponse, DefaultError, Options<SignsCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignsFindAllProcessSuggestionQueryKey = (options?: Options<SignsFindAllProcessSuggestionData>) =>
  createQueryKey('signsFindAllProcessSuggestion', options);

export const backendApiSignsFindAllProcessSuggestionOptions = (options?: Options<SignsFindAllProcessSuggestionData>) =>
  queryOptions<
    SignsFindAllProcessSuggestionResponse,
    DefaultError,
    SignsFindAllProcessSuggestionResponse,
    ReturnType<typeof backendApiSignsFindAllProcessSuggestionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignsFindAllProcessSuggestion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignsFindAllProcessSuggestionQueryKey(options),
  });

export const backendApiSignsRemoveMutation = (
  options?: Partial<Options<SignsRemoveData>>,
): UseMutationOptions<SignsRemoveResponse, DefaultError, Options<SignsRemoveData>> => {
  const mutationOptions: UseMutationOptions<SignsRemoveResponse, DefaultError, Options<SignsRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignsFindOneQueryKey = (options: Options<SignsFindOneData>) =>
  createQueryKey('signsFindOne', options);

export const backendApiSignsFindOneOptions = (options: Options<SignsFindOneData>) =>
  queryOptions<
    SignsFindOneResponse,
    DefaultError,
    SignsFindOneResponse,
    ReturnType<typeof backendApiSignsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignsFindOneQueryKey(options),
  });

export const backendApiSignsUpdateMutation = (
  options?: Partial<Options<SignsUpdateData>>,
): UseMutationOptions<SignsUpdateResponse, DefaultError, Options<SignsUpdateData>> => {
  const mutationOptions: UseMutationOptions<SignsUpdateResponse, DefaultError, Options<SignsUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignsCreateStatusMutation = (
  options?: Partial<Options<SignsCreateStatusData>>,
): UseMutationOptions<SignsCreateStatusResponse, DefaultError, Options<SignsCreateStatusData>> => {
  const mutationOptions: UseMutationOptions<SignsCreateStatusResponse, DefaultError, Options<SignsCreateStatusData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignsCreateStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignCodesFindAllQueryKey = (options?: Options<SignCodesFindAllData>) =>
  createQueryKey('signCodesFindAll', options);

export const backendApiSignCodesFindAllOptions = (options?: Options<SignCodesFindAllData>) =>
  queryOptions<
    SignCodesFindAllResponse,
    DefaultError,
    SignCodesFindAllResponse,
    ReturnType<typeof backendApiSignCodesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignCodesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignCodesFindAllQueryKey(options),
  });

export const backendApiSignCodesFindOneQueryKey = (options: Options<SignCodesFindOneData>) =>
  createQueryKey('signCodesFindOne', options);

export const backendApiSignCodesFindOneOptions = (options: Options<SignCodesFindOneData>) =>
  queryOptions<
    SignCodesFindOneResponse,
    DefaultError,
    SignCodesFindOneResponse,
    ReturnType<typeof backendApiSignCodesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignCodesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignCodesFindOneQueryKey(options),
  });

export const backendApiBemasImportImportPoliceMutation = (
  options?: Partial<Options<BemasImportImportPoliceData>>,
): UseMutationOptions<BemasImportImportPoliceResponse, DefaultError, Options<BemasImportImportPoliceData>> => {
  const mutationOptions: UseMutationOptions<
    BemasImportImportPoliceResponse,
    DefaultError,
    Options<BemasImportImportPoliceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiBemasImportImportPolice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiBemasImportImportOrganizationsMutation = (
  options?: Partial<Options<BemasImportImportOrganizationsData>>,
): UseMutationOptions<
  BemasImportImportOrganizationsResponse,
  DefaultError,
  Options<BemasImportImportOrganizationsData>
> => {
  const mutationOptions: UseMutationOptions<
    BemasImportImportOrganizationsResponse,
    DefaultError,
    Options<BemasImportImportOrganizationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiBemasImportImportOrganizations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindAllQueryKey = (options?: Options<ProcessesFindAllData>) =>
  createQueryKey('processesFindAll', options);

export const backendApiProcessesFindAllOptions = (options?: Options<ProcessesFindAllData>) =>
  queryOptions<
    ProcessesFindAllResponse,
    DefaultError,
    ProcessesFindAllResponse,
    ReturnType<typeof backendApiProcessesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindAllQueryKey(options),
  });

export const backendApiProcessesCreateMutation = (
  options?: Partial<Options<ProcessesCreateData>>,
): UseMutationOptions<ProcessesCreateResponse, DefaultError, Options<ProcessesCreateData>> => {
  const mutationOptions: UseMutationOptions<ProcessesCreateResponse, DefaultError, Options<ProcessesCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindAllNotificationsQueryKey = (options: Options<ProcessesFindAllNotificationsData>) =>
  createQueryKey('processesFindAllNotifications', options);

export const backendApiProcessesFindAllNotificationsOptions = (options: Options<ProcessesFindAllNotificationsData>) =>
  queryOptions<
    ProcessesFindAllNotificationsResponse,
    DefaultError,
    ProcessesFindAllNotificationsResponse,
    ReturnType<typeof backendApiProcessesFindAllNotificationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindAllNotifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindAllNotificationsQueryKey(options),
  });

export const backendApiProcessesRemoveMutation = (
  options?: Partial<Options<ProcessesRemoveData>>,
): UseMutationOptions<ProcessesRemoveResponse, DefaultError, Options<ProcessesRemoveData>> => {
  const mutationOptions: UseMutationOptions<ProcessesRemoveResponse, DefaultError, Options<ProcessesRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindOneQueryKey = (options: Options<ProcessesFindOneData>) =>
  createQueryKey('processesFindOne', options);

export const backendApiProcessesFindOneOptions = (options: Options<ProcessesFindOneData>) =>
  queryOptions<
    ProcessesFindOneResponse,
    DefaultError,
    ProcessesFindOneResponse,
    ReturnType<typeof backendApiProcessesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindOneQueryKey(options),
  });

export const backendApiProcessesUpdateMutation = (
  options?: Partial<Options<ProcessesUpdateData>>,
): UseMutationOptions<ProcessesUpdateResponse, DefaultError, Options<ProcessesUpdateData>> => {
  const mutationOptions: UseMutationOptions<ProcessesUpdateResponse, DefaultError, Options<ProcessesUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateExternalMutation = (
  options?: Partial<Options<ProcessesUpdateExternalData>>,
): UseMutationOptions<ProcessesUpdateExternalResponse, DefaultError, Options<ProcessesUpdateExternalData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateExternalResponse,
    DefaultError,
    Options<ProcessesUpdateExternalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateExternal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateStepDraftMutation = (
  options?: Partial<Options<ProcessesUpdateStepDraftData>>,
): UseMutationOptions<ProcessesUpdateStepDraftResponse, DefaultError, Options<ProcessesUpdateStepDraftData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateStepDraftResponse,
    DefaultError,
    Options<ProcessesUpdateStepDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateStepDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateStepExaminationMutation = (
  options?: Partial<Options<ProcessesUpdateStepExaminationData>>,
): UseMutationOptions<
  ProcessesUpdateStepExaminationResponse,
  DefaultError,
  Options<ProcessesUpdateStepExaminationData>
> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateStepExaminationResponse,
    DefaultError,
    Options<ProcessesUpdateStepExaminationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateStepExamination({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateStepDecisionMutation = (
  options?: Partial<Options<ProcessesUpdateStepDecisionData>>,
): UseMutationOptions<ProcessesUpdateStepDecisionResponse, DefaultError, Options<ProcessesUpdateStepDecisionData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateStepDecisionResponse,
    DefaultError,
    Options<ProcessesUpdateStepDecisionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateStepDecision({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateStepExecutionMutation = (
  options?: Partial<Options<ProcessesUpdateStepExecutionData>>,
): UseMutationOptions<
  ProcessesUpdateStepExecutionResponse,
  DefaultError,
  Options<ProcessesUpdateStepExecutionData>
> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateStepExecutionResponse,
    DefaultError,
    Options<ProcessesUpdateStepExecutionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateStepExecution({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFinalizeProcessMutation = (
  options?: Partial<Options<ProcessesFinalizeProcessData>>,
): UseMutationOptions<ProcessesFinalizeProcessResponse, DefaultError, Options<ProcessesFinalizeProcessData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesFinalizeProcessResponse,
    DefaultError,
    Options<ProcessesFinalizeProcessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesFinalizeProcess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesCancelProcessMutation = (
  options?: Partial<Options<ProcessesCancelProcessData>>,
): UseMutationOptions<ProcessesCancelProcessResponse, DefaultError, Options<ProcessesCancelProcessData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesCancelProcessResponse,
    DefaultError,
    Options<ProcessesCancelProcessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesCancelProcess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesGeneratePdfMutation = (
  options?: Partial<Options<ProcessesGeneratePdfData>>,
): UseMutationOptions<ProcessesGeneratePdfResponse, DefaultError, Options<ProcessesGeneratePdfData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesGeneratePdfResponse,
    DefaultError,
    Options<ProcessesGeneratePdfData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesGeneratePdf({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindAllFilesQueryKey = (options: Options<ProcessesFindAllFilesData>) =>
  createQueryKey('processesFindAllFiles', options);

export const backendApiProcessesFindAllFilesOptions = (options: Options<ProcessesFindAllFilesData>) =>
  queryOptions<
    ProcessesFindAllFilesResponse,
    DefaultError,
    ProcessesFindAllFilesResponse,
    ReturnType<typeof backendApiProcessesFindAllFilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindAllFiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindAllFilesQueryKey(options),
  });

export const backendApiProcessesUploadFileMutation = (
  options?: Partial<Options<ProcessesUploadFileData>>,
): UseMutationOptions<ProcessesUploadFileResponse, DefaultError, Options<ProcessesUploadFileData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUploadFileResponse,
    DefaultError,
    Options<ProcessesUploadFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUploadFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesRemoveFileMutation = (
  options?: Partial<Options<ProcessesRemoveFileData>>,
): UseMutationOptions<ProcessesRemoveFileResponse, DefaultError, Options<ProcessesRemoveFileData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesRemoveFileResponse,
    DefaultError,
    Options<ProcessesRemoveFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesRemoveFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindOneFileQueryKey = (options: Options<ProcessesFindOneFileData>) =>
  createQueryKey('processesFindOneFile', options);

export const backendApiProcessesFindOneFileOptions = (options: Options<ProcessesFindOneFileData>) =>
  queryOptions<
    ProcessesFindOneFileResponse,
    DefaultError,
    ProcessesFindOneFileResponse,
    ReturnType<typeof backendApiProcessesFindOneFileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindOneFile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindOneFileQueryKey(options),
  });

export const backendApiProcessesAddSignMutation = (
  options?: Partial<Options<ProcessesAddSignData>>,
): UseMutationOptions<ProcessesAddSignResponse, DefaultError, Options<ProcessesAddSignData>> => {
  const mutationOptions: UseMutationOptions<ProcessesAddSignResponse, DefaultError, Options<ProcessesAddSignData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesAddSign({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesRemoveSignMutation = (
  options?: Partial<Options<ProcessesRemoveSignData>>,
): UseMutationOptions<ProcessesRemoveSignResponse, DefaultError, Options<ProcessesRemoveSignData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesRemoveSignResponse,
    DefaultError,
    Options<ProcessesRemoveSignData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesRemoveSign({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesCreateExaminationMutation = (
  options?: Partial<Options<ProcessesCreateExaminationData>>,
): UseMutationOptions<ProcessesCreateExaminationResponse, DefaultError, Options<ProcessesCreateExaminationData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesCreateExaminationResponse,
    DefaultError,
    Options<ProcessesCreateExaminationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesCreateExamination({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesRemoveExaminationMutation = (
  options?: Partial<Options<ProcessesRemoveExaminationData>>,
): UseMutationOptions<ProcessesRemoveExaminationResponse, DefaultError, Options<ProcessesRemoveExaminationData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesRemoveExaminationResponse,
    DefaultError,
    Options<ProcessesRemoveExaminationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesRemoveExamination({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesUpdateExaminationMutation = (
  options?: Partial<Options<ProcessesUpdateExaminationData>>,
): UseMutationOptions<ProcessesUpdateExaminationResponse, DefaultError, Options<ProcessesUpdateExaminationData>> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateExaminationResponse,
    DefaultError,
    Options<ProcessesUpdateExaminationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateExamination({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindOneExaminationPublicQueryKey = (
  options: Options<ProcessesFindOneExaminationPublicData>,
) => createQueryKey('processesFindOneExaminationPublic', options);

export const backendApiProcessesFindOneExaminationPublicOptions = (
  options: Options<ProcessesFindOneExaminationPublicData>,
) =>
  queryOptions<
    ProcessesFindOneExaminationPublicResponse,
    DefaultError,
    ProcessesFindOneExaminationPublicResponse,
    ReturnType<typeof backendApiProcessesFindOneExaminationPublicQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindOneExaminationPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindOneExaminationPublicQueryKey(options),
  });

export const backendApiProcessesUpdateExaminationPublicMutation = (
  options?: Partial<Options<ProcessesUpdateExaminationPublicData>>,
): UseMutationOptions<
  ProcessesUpdateExaminationPublicResponse,
  DefaultError,
  Options<ProcessesUpdateExaminationPublicData>
> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateExaminationPublicResponse,
    DefaultError,
    Options<ProcessesUpdateExaminationPublicData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateExaminationPublic({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiProcessesFindOneExecutionPublicQueryKey = (
  options: Options<ProcessesFindOneExecutionPublicData>,
) => createQueryKey('processesFindOneExecutionPublic', options);

export const backendApiProcessesFindOneExecutionPublicOptions = (
  options: Options<ProcessesFindOneExecutionPublicData>,
) =>
  queryOptions<
    ProcessesFindOneExecutionPublicResponse,
    DefaultError,
    ProcessesFindOneExecutionPublicResponse,
    ReturnType<typeof backendApiProcessesFindOneExecutionPublicQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiProcessesFindOneExecutionPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiProcessesFindOneExecutionPublicQueryKey(options),
  });

export const backendApiProcessesUpdateExecutionPublicMutation = (
  options?: Partial<Options<ProcessesUpdateExecutionPublicData>>,
): UseMutationOptions<
  ProcessesUpdateExecutionPublicResponse,
  DefaultError,
  Options<ProcessesUpdateExecutionPublicData>
> => {
  const mutationOptions: UseMutationOptions<
    ProcessesUpdateExecutionPublicResponse,
    DefaultError,
    Options<ProcessesUpdateExecutionPublicData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiProcessesUpdateExecutionPublic({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignImagesFindAllQueryKey = (options: Options<SignImagesFindAllData>) =>
  createQueryKey('signImagesFindAll', options);

export const backendApiSignImagesFindAllOptions = (options: Options<SignImagesFindAllData>) =>
  queryOptions<
    SignImagesFindAllResponse,
    DefaultError,
    SignImagesFindAllResponse,
    ReturnType<typeof backendApiSignImagesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignImagesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignImagesFindAllQueryKey(options),
  });

export const backendApiSignImagesUploadMutation = (
  options?: Partial<Options<SignImagesUploadData>>,
): UseMutationOptions<SignImagesUploadResponse, DefaultError, Options<SignImagesUploadData>> => {
  const mutationOptions: UseMutationOptions<SignImagesUploadResponse, DefaultError, Options<SignImagesUploadData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignImagesUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignImagesRemoveMutation = (
  options?: Partial<Options<SignImagesRemoveData>>,
): UseMutationOptions<SignImagesRemoveResponse, DefaultError, Options<SignImagesRemoveData>> => {
  const mutationOptions: UseMutationOptions<SignImagesRemoveResponse, DefaultError, Options<SignImagesRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiSignImagesRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiSignImagesFindOneQueryKey = (options: Options<SignImagesFindOneData>) =>
  createQueryKey('signImagesFindOne', options);

export const backendApiSignImagesFindOneOptions = (options: Options<SignImagesFindOneData>) =>
  queryOptions<
    SignImagesFindOneResponse,
    DefaultError,
    SignImagesFindOneResponse,
    ReturnType<typeof backendApiSignImagesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiSignImagesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiSignImagesFindOneQueryKey(options),
  });

export const backendApiExternalSignsUploadMutation = (
  options?: Partial<Options<ExternalSignsUploadData>>,
): UseMutationOptions<unknown, DefaultError, Options<ExternalSignsUploadData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ExternalSignsUploadData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiExternalSignsUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiExternalSignsImportMutation = (
  options?: Partial<Options<ExternalSignsImportData>>,
): UseMutationOptions<ExternalSignsImportResponse, DefaultError, Options<ExternalSignsImportData>> => {
  const mutationOptions: UseMutationOptions<
    ExternalSignsImportResponse,
    DefaultError,
    Options<ExternalSignsImportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiExternalSignsImport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOpenLrImportMutation = (
  options?: Partial<Options<OpenLrImportData>>,
): UseMutationOptions<OpenLrImportResponse, DefaultError, Options<OpenLrImportData>> => {
  const mutationOptions: UseMutationOptions<OpenLrImportResponse, DefaultError, Options<OpenLrImportData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOpenLrImport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
